'use client';

import React from 'react';
import VideoPlayer from '@/components/VideoPlayer';
import { useUserCountry } from '@/utils/useUserCountry';
import type { PostNode } from '@/types/global';
import { safeHtmlLinks } from '@/utils/links/safeHref';

type Props = {
    post?: PostNode;
    headerData?: { broker?: { about?: string } };
};

const VideoTutorial: React.FC<Props> = ({ post, headerData }) => {
    const { userCountry } = useUserCountry();

    const aparat = post?.posts_acf?.aparatHnembed ?? null;
    const youtube = post?.posts_acf?.youtubeHnembed ?? null;

    // explicit visibility flags
    const showAparat = userCountry === 'IR' && !!aparat;
    const showYouTube = userCountry !== 'IR' && !!youtube;
    const showVideo = showAparat || showYouTube;

    const gridCols = showVideo ? 'lg:grid-cols-2' : 'lg:grid-cols-1';

    return (
        <section
            className={`grid ${gridCols} gap-4 border-b dark:border-white/20 py-5 mb-3 lg:mt-6 lg:pl-3`}
        >
            {/* Video column - render ONLY if the required embed exists */}
            {showVideo && (
                <div>
                    <h2 className='text-xl mb-3'>
                        {'ویدیو آموزشی ' + (post?.brokerSingle?.newfields?.faName ?? '')}
                    </h2>
                    <VideoPlayer
                        // pass only the relevant embed to avoid any accidental load path
                        aparatHnembed={showAparat ? aparat! : undefined}
                        youtubeHnembed={showYouTube ? youtube! : undefined}
                        classNameCustom='lg:!mt-0 aspect-video'
                    />
                </div>
            )}

            {/* Intro / About column */}
            <div className='max-lg:order-first'>
                <h2 className='text-xl mb-3'>
                    {'معرفی ' + (post?.brokerSingle?.newfields?.faName ?? '')}
                </h2>
                <div
                    className='post-content prose mx-auto max-w-full text-justify dark:max-lg:[&>p]:!text-white/80'
                    dangerouslySetInnerHTML={{
                        __html: safeHtmlLinks(headerData?.broker?.about || ''),
                    }}
                />
            </div>
        </section>
    );
};

export default VideoTutorial;
